export enum Column {
  Checkbox = "checkbox",
  Requester = "requester",
  Subject = "subject",
  Assignee = "assignee",
  Status = "status",
  UnrepliedSince = "unrepliedSince",
  LastMessageDate = "lastMessageDate",
  LastActivity = "lastActivity",
  Options = "options",
  Mobile = "mobile",
  MobileOptions = "mobileOptions",
}

export const ColumnWidths: { [key in Column]?: number } = {
  [Column.Checkbox]: 16,
  [Column.Requester]: 200,
  [Column.Assignee]: 160,
  [Column.Status]: 70,
  [Column.UnrepliedSince]: 150,
  [Column.LastMessageDate]: 150,
  [Column.LastActivity]: 150,
  [Column.Options]: 26,
  [Column.Mobile]: 200,
  [Column.MobileOptions]: 26,
};
